// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerPortalLink_container__2wpKh"};